// hljs.initHighlightingOnLoad();
// hljs.initLineNumbersOnLoad();

$(document).ready(function () {

    demun.init();
    //   $('code.hljs').each(function (i, block) {
    //     hljs.lineNumbersBlock(block);
    //   });

});
